//export module Models {
export class GetUserByIdCrossModel {
    constructor() {
        this.userId = 0;
        this.name = null;
        this.email = null;
        this.language = null;
        this.password = null;
        this.createTime = null;
        this.createIp = null;
        this.updateTime = null;
        this.updateIp = null;
        this.active = false;
        this.loginIP = null;
        this.loginTime = null;
        this.parentUserId = null;
        this.createPortalId = 0;
        this.coach = null;
        this.premiumDate = null;
        this.errorMessage = null;
    }
}
//}
